export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat("en-EN", {
    style: "currency",
    currency: "USD",
  }).format(value || 0);
};

export const formatCurrencyNoCent = (value: number) => {
  return new Intl.NumberFormat("en-EN", {
    style: "currency",
    currency: "USD",
    maximumSignificantDigits: 3,
  }).format(value || 0);
};

export const formatPercentage = (value: number) => {
  return new Intl.NumberFormat("en-EN", {
    style: "percent",
    maximumFractionDigits: 2,
  }).format(value || 0);
};

export const formatPercentageShort = (value: number) => {
  return new Intl.NumberFormat("en-EN", {
    style: "percent",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(value || 0);
};

export const shortNumber = (value: number) => {
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value || 0);
};

export const formatNumber = (value: number) => {
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(value || 0);
};

export const formatMilliseconds = (value: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "unit",
    unit: "millisecond",
  }).format(value || 0);
};
